/*
 * OUTEQ — lehký wishlist přes localStorage.
 * Klíč: 'outeqWishlist' = pole product handlů (sdílené s outeq-bestsellers).
 *
 * - Klik na cokoliv s [data-wishlist] (+ handle z data-wishlist-handle /
 *   nejbližší [data-handle] / [data-product-handle]) přepne uložení.
 * - [data-wishlist-count] = badge s počtem (skryje se při 0).
 * - [data-wishlist-grid] = mřížka na stránce Oblíbené; produkty se dotáhnou
 *   přes /products/<handle>.js a vyrenderují klientsky.
 * - [data-wishlist-add] (data-variant-id) = přidání do košíku ze stránky.
 */
(function () {
  'use strict';

  // Skript se může načíst dvakrát (globálně v theme.liquid + v sekci wishlist).
  // Guard zajistí jen jednu inicializaci (jinak by se klik na srdce přepnul 2×).
  if (window.__outeqWishlistInit) return;
  window.__outeqWishlistInit = true;

  var LS_KEY = 'outeqWishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var l = read(); var i = l.indexOf(h);
    if (i === -1) { l.push(h); } else { l.splice(i, 1); }
    write(l); emit(); return i === -1;
  }
  function remove(h) {
    var l = read(); var i = l.indexOf(h);
    if (i !== -1) { l.splice(i, 1); write(l); emit(); }
  }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: read().length } })); } catch (e) {}
  }

  window.OuteqWishlist = { read: read, has: has, toggle: toggle, remove: remove };

  /* ---------- helpers ---------- */
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return Math.round(cents / 100) + ' Kč'; }
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function handleOf(btn) {
    if (btn.getAttribute('data-wishlist-handle')) return btn.getAttribute('data-wishlist-handle');
    var c = btn.closest('[data-handle]'); if (c) return c.getAttribute('data-handle');
    var p = btn.closest('[data-product-handle]'); if (p) return p.getAttribute('data-product-handle');
    return null;
  }

  /* ---------- reflect state (idempotentně — aby neloopoval MutationObserver) ---------- */
  function reflect(btn) {
    var h = handleOf(btn); if (!h) return;
    var a = has(h);
    if (btn.classList.contains('is-active') !== a) btn.classList.toggle('is-active', a);
    var ap = a ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== ap) btn.setAttribute('aria-pressed', ap);
  }
  function reflectAll() {
    document.querySelectorAll('[data-wishlist]').forEach(reflect);
    var n = String(read().length);
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== n) el.textContent = n;
      var hide = n === '0';
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  /* ---------- klikací delegace ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var h = handleOf(btn); if (h) toggle(h);
      return;
    }
    var add = e.target.closest('[data-wishlist-add]');
    if (add) { e.preventDefault(); addToCart(add); }
  });

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var def = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'outeq-wishlist', data: { source: 'wishlist', itemCount: cart.item_count } } }));
        btn.textContent = '✓ Přidáno';
      })
      .catch(function () { btn.textContent = 'Chyba — zkuste znovu'; })
      .finally(function () { setTimeout(function () { btn.textContent = def; btn.disabled = false; }, 1800); });
  }

  /* ---------- stránka Oblíbené ---------- */
  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    if (!list.length) {
      grid.innerHTML = '';
      grid.removeAttribute('aria-busy');
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(cardHTML).join('');
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      if (!html && empty) empty.hidden = false;
    });
  }

  function cardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    var cta = (v && v.available)
      ? '<button class="oq-wish-card__add" type="button" data-wishlist-add data-variant-id="' + v.id + '">Do košíku</button>'
      : '<div class="oq-wish-card__soldout">Vyprodáno</div>';
    return '' +
      '<div class="oq-wish-card" data-handle="' + esc(p.handle) + '">' +
        '<button class="oq-wish-card__remove" type="button" data-wishlist data-wishlist-handle="' + esc(p.handle) + '" aria-label="Odebrat z oblíbených">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
        '</button>' +
        '<a class="oq-wish-card__media" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + sized(img, 600) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="oq-wish-card__body">' +
          (p.vendor ? '<div class="oq-wish-card__brand">' + esc(p.vendor) + '</div>' : '') +
          '<a class="oq-wish-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="oq-wish-card__price">' + money(p.price) + '</div>' +
          cta +
        '</div>' +
      '</div>';
  }

  /* ---------- init + sync ---------- */
  function init() { reflectAll(); renderGrid(); }

  document.addEventListener('wishlist:change', function () { reflectAll(); renderGrid(); });
  document.addEventListener('shopify:section:load', function () { reflectAll(); renderGrid(); });

  // Dynamicky přidané karty (filtry / stránkování) → znovu obarvit srdce.
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(reflectAll, 200); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
